import { List } from '@sayyesschool/frontend/ui-components';

import SectionsListItem from './SectionsListItem';

export default function SectionsList({ sections, onReorder, onDelete }) {
    return (
        <List className="SectionsList NumberedList">
            {sections.map((section, index) =>
                <SectionsListItem
                    key={section.id}
                    index={index}
                    section={section}
                    first={index === 0}
                    last={index === sections.length - 1}
                    onMove={onReorder}
                    onDelete={onDelete}
                />
            )}
        </List>
    );
}